<template>
    <b-card no-body>

        <b-modal id="create" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <shift-time-create-or-update v-model="shiftTime" :errors="errors"></shift-time-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="create"></v-executer></template>
        </b-modal>

        <b-modal id="cancel" title="Bitir" no-close-on-esc no-close-on-backdrop>
            <shift-time-cancel v-model="shiftTimeCancel"></shift-time-cancel>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" text="Bitir" :action="cancelShift"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import ShiftTimeCreateOrUpdate from './components/ShiftTimeCreateOrUpdate.vue'
import ShiftTimeCancel from './components/ShiftTimeCancel.vue'

export default {
    components:{
        BCard,
        ShiftTimeCreateOrUpdate,
        ShiftTimeCancel
    },
    data(){
        return {
            fields:[
                {name:"Şube",key:"Branch.Name",thClass:'w-13'},
                {name:"Organizasyonel Konum",key:"CollarStatus.Name",thClass:'w-10'},
                {name:"Başlangıç Tarihi",key:"ValidityStartDateStr",thClass:'w-10'},
                {name:"Bitiş Tarihi",key:"ValidityEndDateStr",thClass:'w-10'},
                {name:"Pazartesi",key:"Days.Monday",thClass:'w-11'},
                {name:"Salı",key:"Days.Tuesday",thClass:'w-11'},
                {name:"Çarşamba",key:"Days.Wednesday",thClass:'w-11'},
                {name:"Perşembe",key:"Days.Thursday",thClass:'w-11'},
                {name:"Cuma",key:"Days.Friday",thClass:'w-11'},
                {name:"Cumartesi",key:"Days.Saturday",thClass:'w-11'},
                {name:"Pazar",key:"Days.Sunday",thClass:'w-11'},
            ],
            buttons:[
                { text:"Bitir",key:"edit",icon:"XSquareIcon",variant:"danger",action:this.cancel},
            ],
            errors:{},
            editing:false,
            loading:false,
            shiftTime:{
                Id:null,
                BranchId:null,
                CollarStatusId:null,
                ValidityEndDate:null,
                ValidityStartDate:null,
                DaysOfWeek:[
                    { day:"Monday",name:"Pazartesi",value:null },
                    { day:"Tuesday",name:"Salı",value:null },
                    { day:"Wednesday",name:"Çarşamba",value:null },
                    { day:"Thursday",name:"Perşembe",value:null },
                    { day:"Friday",name:"Cuma",value:null },
                    { day:"Saturday",name:"Cumartesi",value:null },
                    { day:"Sunday",name:"Pazar",value:null }
                ]
            },
            shiftTimeCancel:{
                Id:null,
                ValidityEndDate:null
            }
        }
    },
    methods:{
        clearForm(){
            this.shiftTime.Id = null
            this.shiftTime.BranchId = null
            this.shiftTime.CollarStatusId = null
            this.shiftTime.StartDate = null
            this.shiftTime.ValidityEndDate = null
            this.shiftTime.ValidityStartDate = [
                { day:"Monday",name:"Pazartesi",value:null },
                { day:"Tuesday",name:"Salı",value:null },
                { day:"Wednesday",name:"Çarşamba",value:null },
                { day:"Thursday",name:"Perşembe",value:null },
                { day:"Friday",name:"Cuma",value:null },
                { day:"Saturday",name:"Cumartesi",value:null },
                { day:"Sunday",name:"Pazar",value:null }
            ]
            this.shiftTimeCancel.Id = null
            this.shiftTimeCancel.ValidityEndDate = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create')
        },
        cancel(item){
            this.clearForm()
            this.shiftTimeCancel.Id = item.Id
            this.$showModal('cancel')
        },
        provider(data){
            return HumanResourcesParameterApi.ShiftTime.Table(data)
        },
        create(){
            this.loading = true
            HumanResourcesParameterApi.ShiftTime.Create({
                ...this.shiftTime,
                DaysOfWeek:this.shiftTime.DaysOfWeek.reduce((o,i)=>{
                    Object.assign(o,{[i.day]:i.value})
                    return o
                },{})
            }).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        cancelShift(){
            HumanResourcesParameterApi.ShiftTime(this.shiftTimeCancel.Id,this.ShiftTimeCancel.ValidityEndDate).then(res=>{
                if(res.data.Success){

                }
            })
        }
    }
}
</script>

<style>

</style>